import { IGrid, INDEX } from 'typings';

function copyGrid(grid: IGrid): IGrid {
    const gridCopy: IGrid = [
        [0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0],
    ]

    for (let r: INDEX = 0; r < 9; r++)
        for (let c: INDEX = 0; c < 9; c++) gridCopy[r][c] = grid[r][c]

    return gridCopy;
}
export default copyGrid;